<template>
  <div class="company-list-page page-content">
    <el-row class="page-header -with-search-bar" type="flex" justify="space-between">
      <el-col :span="6">
        <h2 class="page-title">รายชื่อบริษัท</h2>
      </el-col>
      <el-col :span="10">
        <el-input
          placeholder="ค้นหารายชื่อบริษัท"
          v-model="searchTerm"
          class="input-with-select">
          <el-button slot="append" icon=""></el-button>
        </el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" class="search-button" @click.prevent="searchCompany">
          <span class="text">ค้นหา</span> <i class=""></i>
        </el-button>
      </el-col>
      <el-col :span="5">
        <el-button type="primary" class="search-button" @click.prevent="createCompany" v-if="!isViewerRole">
          <span class="text">เพิ่มรายชื่อบริษัท</span> <i class="el-icon-plus el-icon-right"></i>
        </el-button>
      </el-col>
    </el-row>
    <div class="company-list-table">
      <!--<el-pagination
        layout="prev, pager, next, jumper"
        background
        :current-page.sync="companyListDataCurrentPage"
        :page-size="companyListDataItemPerPage"
        :total="companyListData.length">
      </el-pagination>-->
      <el-table
        :data="companyList"
        @sort-change="dataTableSorted"
        v-loading="isSortingData"
        :default-sort = "{prop: 'name', order: 'ascending'}"
        style="width: 100%">
        <el-table-column
          prop="name"
          label="ชื่อบริษัท"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="profiles_count"
          label="จำนวนบริษัทรับชำระ"
          header-align="center"
          align="center"
          width="180">
        </el-table-column>
        <el-table-column
          prop="address"
          label="ที่อยู่บริษัท"
          class-name="address-col no-wrap"
          min-width="300"
          :formatter="addressFormatter">
        </el-table-column>
        <el-table-column
          prop="address.tel"
          label="โทรศัพท์"
          :formatter="telFormatter"
          width="100">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="ตัวเลือก"
          header-align="center"
          align="center"
          class-name="action-col"
          width="80">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              size="mini"
              @click.prevent="handleManage(scope.$index, scope.row)"
              class="action-btn">
              {{ isViewerRole ? 'ดูข้อมูล' : 'จัดการ' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        
        layout="prev, pager, next, jumper"
        background
        :current-page.sync="companyListDataCurrentPage"
        :page-size="query.limit">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/* eslint no-param-reassign: 0 */
// import store from '@/store';
import { createMask } from 'imask';
import asyncMergeSort from 'async-merge-sort';
import moment from 'moment-timezone';
// import lunr from 'lunr';
// import _ from 'lodash';

/**
 * Company List view
 */
const CompanyListView = {
  name: 'company-list',
  data() {
    return {
      isSubmitting: false,
      searchTerm: '',
      indexer: null,
      isSortingData: false,
      companyListDataSorted: [],
      companyListDataCurrentPage: 1,
      companyListDataItemPerPage: 100,
      mask: {
        tel: {
          mask: [
            { mask: '{02}-000-0000' },
            { mask: '{0}00-000-000' },
            { mask: '{0}00-000-0000' },
          ],
        },
      },
      query: {
        limit: 20,
        offset: 0,
        name__like: null
      }
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isViewerRole() {
      return this.$store.getters.isViewerRole;
    },
    companyList() {
      return this.$store.getters.companyList;
    },
    companyListData() {
      // return this.$store.getters.companyList;
      /* if (this.indexer && this.searchTerm.trim() !== '') {
        const res = this.indexer.search(this.searchTerm.trim().toLowerCase());
        // build result list
        const refs = res.map(item => parseInt(item.ref, 10));
        return this.companyList.filter(item => refs.indexOf(item.id) !== -1);
      } */
      // const q = this.searchTerm.trim().toLowerCase();
      // if (q !== '') {
      //   return this.companyList.filter((item) => {
      //     const name = item.name.trim().toLowerCase();
      //     return name.indexOf(q) !== -1;
      //   });
      // }
      return this.companyList;
    },
    companyListDataPaged() {
      // apply pagination data
      let offsetIndex = (this.companyListDataCurrentPage - 1) * this.companyListDataItemPerPage;
      let offsetEndIndex = offsetIndex + this.companyListDataItemPerPage;
      if (offsetIndex >= this.companyListData.length) {
        offsetIndex = this.companyListData.length - 1;
      }
      if (offsetEndIndex > this.companyListData.length) {
        offsetEndIndex = this.companyListData.length;
      }
      return this.companyListDataSorted.slice(offsetIndex, offsetEndIndex);
    },
    companyListDataTotalPage() {
      return Math.ceil(this.companyListData.length / this.companyListDataItemPerPage);
    },
    algoliaApiKey() {
      return process.env.ALGOLIA_API_KEY;
    },
    vm() {
      return this;
    },
  },
  methods: {
    createCompany() {
      this.$router.push({ name: 'CompanyCreate' });
    },
    searchCompany() {
      this.query.name__like = this.searchTerm
      if (!this.searchTerm) {
        this.query.name__like = null
      }
      this.$store.dispatch('START_CONTENT_LOADING');
      this.$store.dispatch('GET_COMPANY_LIST', this.query).then(() => {
        this.$store.dispatch('STOP_CONTENT_LOADING');
      }).catch((err) => {
        this.$store.dispatch('STOP_CONTENT_LOADING');
        this.$store.dispatch('ADD_ERROR_FLASH', err);
      });
    },

    addressFormatter(row) {
      return `${row.address.line_1}
        ${row.address.district}
        ${row.address.city}
        ${row.address.province}
        ${row.address.postal_code}`;
    },
    telFormatter(row) {
      const val = row.address.tel;
      if (val) {
        // return this.maskFormatter(val, this.mask.tel);
        return val;
      }
      return '-';
    },
    maskFormatter(val, maskOptions) {
      const mask = createMask(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    },
    handleManage(index, row) {
      this.$router.push({
        name: 'CompanyDetail',
        params: {
          companyId: row.id,
        },
      });
    },
    dataTableSorted({ prop, order }) {
      if (prop && order) {
        this.isSortingData = true;
        let type = 'string';
        let sortProp = prop;
        if (order === 'descending') {
          sortProp = `-${sortProp}`;
        }
        /* if (prop === 'issued_on') {
          // sort by date
          type = 'date';
        } else */
        if (prop === 'profiles_count') {
          // sort by number
          type = 'number';
        }
        asyncMergeSort(this.companyListData,
          this.dynamicSort(sortProp, type),
          (err, sorted) => {
            this.isSortingData = false;
            if (!err) {
              this.companyListDataSorted = sorted;
            }
          });
      } else {
        // reset sorting
        this.companyListDataSorted = JSON.parse(JSON.stringify(this.companyListData));
      }
      // force hide loading after 5 seconds
      setTimeout(() => {
        if (this.isSortingData) {
          this.isSortingData = false;
        }
      }, 5000);
    },
    dynamicSort(prop, type) {
      let sortOrder = 1;
      if (prop[0] === '-') {
        sortOrder = -1;
        prop = prop.substr(1);
      }
      return (a, b, cb) => {
        // const result = (a[prop] < b[prop]) ? -1 : (a[prop] > b[prop]) ? 1 : 0;
        let result = 0;
        let aValue = a[prop];
        let bValue = b[prop];
        if (type === 'date') {
          const aDate = moment(aValue).tz(process.env.DEFAULT_TZ);
          if (aDate.isValid()) {
            aValue = Number(aDate.format('X'));
          }
          const bDate = moment(bValue).tz(process.env.DEFAULT_TZ);
          if (bDate.isValid()) {
            bValue = Number(bDate.format('X'));
          }
        } else if (type === 'number') {
          aValue = Number(aValue);
          bValue = Number(bValue);
        }
        if (aValue < bValue) {
          result = -1;
        } else if (aValue > bValue) {
          result = 1;
        }
        return cb(null, result * sortOrder);
      };
    },
    /* filterItem: _.debounce((vm) => {
      if (vm.indexer && vm.searchTerm.trim() !== '') {
        const res = this.indexer.search(vm.searchTerm.trim().toLowerCase());
        // build result list
        const refs = res.map(item => item.ref);
        const result = this.companyList.filter(item => refs.indexOf(item.id) !== -1);
        this.companyListData = result;
      } else {
        this.companyListData = this.companyList;
      }
    }, 150), */
    /* querySearch(queryString, cb) {
      if (this.indexer) {
        const res = this.indexer.search(queryString);
        // build result list
        const result = [];
        res.forEach((item) => {
          const key = `_${item.ref}`;
          if (typeof this.$store.getters.companyListIndex[key] !== 'undefined') {
            const index = this.$store.getters.companyListIndex[key];
            if (typeof this.companyList[index] !== 'undefined') {
              result.push({
                value: this.companyList[index].name,
              });
            }
          }
        });
        cb(result);
      } else {
        cb([]);
      }
    }, */
    /* setIndexer(indexer) {
      this.indexer = indexer;
    }, */
  },
  // Handle Routing
  beforeRouteEnter(to, from, next) {
    // Fetch data
    /* store.dispatch('START_CONTENT_LOADING');
    store.dispatch('GET_COMPANY_LIST').then(() => {
      store.dispatch('STOP_CONTENT_LOADING');
    }).catch((err) => {
      store.dispatch('STOP_CONTENT_LOADING');
      store.dispatch('ADD_ERROR_FLASH', err);
    }); */
    next((vm) => {
      vm.$nextTick(() => {
        vm.$store.dispatch('START_CONTENT_LOADING');
        vm.$store.dispatch('GET_COMPANY_LIST', vm.query).then(() => {
          vm.$store.dispatch('STOP_CONTENT_LOADING');
        }).catch((err) => {
          vm.$store.dispatch('STOP_CONTENT_LOADING');
          vm.$store.dispatch('ADD_ERROR_FLASH', err);
        });
      });
      // vm.$store.dispatch('STOP_CONTENT_LOADING');
      // build indexer
      // vm.companyListData = vm.companyList;
      /* vm.setIndexer(lunr((builder) => {
        builder.field('name');

        vm.companyList.forEach((item) => {
          const { name, id } = JSON.parse(JSON.stringify(item));
          builder.add({
            name,
            id,
          });
        });
      })); */
    });
  },
  watch: {
    companyListDataCurrentPage(val) {
      this.query.offset = (val-1) * this.query.limit
      this.$store.dispatch('START_CONTENT_LOADING');
      this.$store.dispatch('GET_COMPANY_LIST', this.query).then(() => {
        this.$store.dispatch('STOP_CONTENT_LOADING');
      }).catch((err) => {
        this.$store.dispatch('STOP_CONTENT_LOADING');
        this.$store.dispatch('ADD_ERROR_FLASH', err);
      });
    },

    companyListData(newList, oldList) {
      if (newList && oldList !== newList) {
        this.companyListDataSorted = JSON.parse(JSON.stringify(newList));
      }
    },
    companyListDataSorted() {
      this.isSortingData = false;
    },
  },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  /* beforeRouteUpdate(to, from, next) {
    // Fetch data
    store.dispatch('START_CONTENT_LOADING');
    store.dispatch('GET_COMPANY_LIST').then(() => {
      store.dispatch('STOP_CONTENT_LOADING');
    }).catch((err) => {
      store.dispatch('STOP_CONTENT_LOADING');
      store.dispatch('ADD_ERROR_FLASH', err);
    });
    next();
  }, */
};
export default CompanyListView;
</script>

<style lang="scss">
  .company-list-page {
    .company-list-table {
      .address-col {
        .cell {
          text-overflow: ellipsis;
          // height: 23px;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/company/company-list.vue